import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

export const otherInfoRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct other info'),
    max: 1024,
  });
};
